<template>
  <div class="row">
    <div class="col-6 form-stylizer">
      <b-form-group
        id="clients-group"
        label="Client *"
        label-for="client-input"
      >
        <b-form-select
          id="client-input"
          name="societe"
          v-model="form.client"
          :options="clientList"
          @change="handleChange"
          v-validate="'required'"
        >
          <template slot="first">
            <option :value="null" disabled>Veuillez choisir un client</option>
          </template>
        </b-form-select>
      </b-form-group>
      <b-form-group
        id="denomination-group"
        label="Dénomination du batiment *"
        label-for="denomination-input"
      >
        <b-form-input
          v-model="form.nom"
          name="nom"
          id="denomination-input"
          type="text"
          v-validate="'required'"
        >
        </b-form-input>
      </b-form-group>
    </div>
    <div class="col-6">
      <b-form-group
        id="type-equipement-group"
        label="Type d'équipement"
        label-for="denomination-input"
      >
        <multiselect
          v-model="typeErpValue"
          :options="options"
          :multiple="true"
          group-values="subcategory"
          group-label="category"
          :group-select="true"
          placeholder="Rechercher"
          track-by="nom"
          label="nom"
          :close-on-select="false"
          :show-labels="false"
          @input="formatErp"
        >
        </multiselect>
      </b-form-group>
    </div>
    <div class="col-12">
      <div class="button-wrap validation-button d-flex justify-content-end">
        <p class="obligatoire">* Champs obligatoire</p>
        <b-button variant="outline-primary" @click.prevent="previousStep"
          >Annuler</b-button
        >
        <b-button
          type="button"
          variant="outline-primary"
          class="lg-btn"
          @click.prevent="nextStep"
          >Suivant</b-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  data () {
    return {
      form: {
        nom: '',
        typeErp: [],
        client: null
      },
      clientList: [],
      selected: 1,
      value: [],
      options: [],
      typeErpValue: []
    }
  },
  mounted () {
    this.createOptionsErp()
    this.listClient()
  },
  methods: {
    ...mapActions(['getTypeErp', 'listAdminClient']),
    ...mapGetters(['userSocieteId']),
    handleChange (option) {

    },
    createOptionsErp () {
      this.getTypeErp().then((resp) => {
        let optionsTest = []
        Object.keys(resp.items).forEach(function (item) {
          let option = {}
          option.category = resp.items[item].categorieErpNom
          option.subcategory = resp.items[item].typeErp
          optionsTest.push(option)
        })
        this.options = optionsTest
      })
    },
    listClient () {
      this.listAdminClient({ data: this.userSocieteId(), page: 0 }).then((resp) => {
        let options = []
        resp.items.forEach(item => {
          let option = {}
          option.value = item.id
          option.text = item.nom
          options.push(option)
        })
        this.clientList = options
      })
    },
    formatErp () {
      this.form.typeErp = this.typeErpValue.map(x => x.id)
    },
    previousStep () {
      this.$emit('cancel')
    },
    nextStep () {
      this.$validator.validate().then(valid => {
        if (!valid) {
          this.$toaster.error('Veuillez remplir les champs obligatoires')
          return
        }
        this.$emit('nextStep', 2)
        this.$emit('dataForm', this.form)
      })
      /*  */
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/creationProjectModal/stepOne.vue